export default "__VITE_ASSET__e483e8e0__"